import {z} from 'zod';

// lng, lat, ?alt

export const geolocationSchema = z.tuple([
  z.number().min(-180).max(180),
  z.number().min(-86).max(86),
]);

export const geolocationWithAltitudeSchema = z.tuple([
  z.number().min(-180).max(180),
  z.number().min(-86).max(86),
  z.number().optional().nullable(),
]);
